import React from 'react';

// import FaqAccordionComponent from '../../../core/components/accordion/accordion';
// import { FaqAccordionItem } from '../../../core/components/accordion/accordion-types';
import { AppComponent } from '../../../core/types/core-types';

import FaqAccordionComponent from './faq-accordion';
import { FaqAccordionItemProps } from './faq-accordion-types';

const FaqAccordion: AppComponent<{
  accordions?: FaqAccordionItemProps[];
  title?: string;
  hasTitle?: boolean;
}> = ({ accordions, title, hasTitle }) => {
  if (!accordions) {
    return null;
  }

  return (
    <FaqAccordionComponent
      items={accordions}
      title={title}
      hasTitle={hasTitle || false}
    />
  );
};

export default FaqAccordion;
